"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountsApi = void 0;
exports.accountsApi = (http, prefix = '/properties') => ({
    create(propertyId, account) {
        return http.post(`${prefix}/${propertyId}/account`, account);
    }
});
//# sourceMappingURL=accounts.js.map